import { gql } from "apollo-boost";

const GET_PRODUCT_SETTING = gql`
  query {
    getProductSetting {
      data {
        isAutoPublish
        isProductSync
        productApproval
        updatedAt
        isCatalogHidden
        isPriceTaxInclusive
        rate
        isHideTagAndType
        isHideTag
        isHideType
      }
      error
      status
    }
  }
`;

export default GET_PRODUCT_SETTING;
